import { formatProceduralText } from '../../lib/proceduralText'

const URL_REGEX_SOURCE = 'https?:\\/\\/[^\\s<>"\']+'

/**
 * Randează text cu URL-urile transformate în link-uri clickabile (se deschid în tab nou).
 */
export default function Linkify({ text, className, ...rest }) {
    if (!text) return null
    const displayText = formatProceduralText(text)

    const parts = []
    let last = 0
    let match

    const urlRegex = new RegExp(URL_REGEX_SOURCE, 'g')
    while ((match = urlRegex.exec(displayText)) !== null) {
        if (match.index > last) {
            parts.push(displayText.slice(last, match.index))
        }
        const url = match[0]
        parts.push(
            <a
                key={match.index}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="linkify-link"
                onClick={(e) => e.stopPropagation()}
            >
                {url}
            </a>
        )
        last = match.index + url.length
    }

    if (last < displayText.length) {
        parts.push(displayText.slice(last))
    }

    return <span className={className} {...rest}>{parts}</span>
}
